export default __webpack_public_path__ + "static/media/avatar_mice1.e03c922f.mp3";